import {gql, useLazyQuery} from "@apollo/client";

const VERIFY_SIGNIN_BY_EMAIL = gql`
    query verifySigninByEmail($loginSessionToken: String!, $verificationCode: String!) {
        verifySigninByEmail(loginSessionToken: $loginSessionToken, verificationCode: $verificationCode) {
            id
            login_type
            username
            nickname
            access_token
            refresh_token
            following_count
            follower_count
            bio
            resizedSmallImage
            resizedBigImage
            email
            phone
            gender
            createdAt
            updatedAt
            isBusiness
            seller {
                id
                income
                rating
                sold_count
                fee
                is_tester
                is_certified
                seller_account {
                    bank_name
                    account_holder_name
                    bank_account
                }
            }
        }
    }
`;

export default function useVerifyPhoneCode() {
    return useLazyQuery(VERIFY_SIGNIN_BY_EMAIL, {
        fetchPolicy: 'network-only',
    });
}
